import { Controller } from "@hotwired/stimulus";

const STATE_MAP = {
  both: { emailRequired: true, phoneRequired: true, phoneOrEmailRequired: false },
  email_only: { emailRequired: true, phoneRequired: false, phoneOrEmailRequired: false },
  phone_only: { emailRequired: false, phoneRequired: true, phoneOrEmailRequired: false },
  phone_or_email: { emailRequired: false, phoneRequired: false, phoneOrEmailRequired: true },
  neither: { emailRequired: false, phoneRequired: false, phoneOrEmailRequired: false },
};

export default class extends Controller {
  static targets = ["select", "emailRequired", "phoneRequired", "phoneOrEmailRequired", "warning"];

  changed() {
    const value = this.selectTarget.value;
    const state = STATE_MAP[value];

    if (!state) return;

    this.emailRequiredTarget.value = state.emailRequired;
    this.phoneRequiredTarget.value = state.phoneRequired;
    this.phoneOrEmailRequiredTarget.value = state.phoneOrEmailRequired;

    this.warningTarget.classList.toggle("hidden", value !== "neither");
  }
}
